import React, { Component } from 'react';
import {
	Row,
	Col,
	FormControl,
	FormGroup,
	FormLabel,
	ButtonGroup,
	Button,
} from 'react-bootstrap';
import { toast } from 'react-toastify';
import {
	Accordion as PrimeAccordion,
	AccordionTab,
} from 'primereact/accordion';
import ptBR from 'date-fns/locale/pt-BR';
import { registerLocale } from 'react-datepicker';
import Spinner from '@atlaskit/spinner';

import Popout from '../../components/Popout';
import LoadingButton from '../../components/LoadingButton';
import api from '../../api';
import { withUser } from '../../modules/User';

import './styles.scss';
import CustomerPerformance from './CustomerPerformance';

registerLocale('ptBR', ptBR);

const getValueFromOption = ({ value }) => value;

const articleToOptions = ({ code, description }) => ({
	label: `${code} - ${description}`,
	value: code,
});

const defaultButtonStyle = {
	width: '100%',
};

const INITIAL_STATE = {
	// Canceled orders
	customerPerformance: [],

	// Filters
	// representante: '', // removido para não limpar representante ao rodar handleCLear
	searchedRepresentante: '',
	searchedSupervisor: [],

	// Selected
	articlesSelected: [],

	// Page State
	isLoading: false,
	activeIndex: 0,
};

class CanceledOrders extends Component {
	state = {
		...INITIAL_STATE,
		representante: this.props.userProps
			? this.props.userProps.representativeId
			: '',
	};

	// Lifecycle
	componentDidMount() {
		this.handleGetQuotaArticles();
	}

	componentDidUpdate() {
		// Quando já está logado, ao entrar na pg a request de usuário ainda não vai ter retornado o ID do representante
		// Então, é necessário rodar um spinner (está lá no render) até que tenha um objeto de user
		// Quando entrar o objeto de user, o componentDidUpdate dispara e verifica se chego
		// Caso sim, verifica se existe repId ou se é igual a 0 E, se o representante no estado está vazio e é diferente de 0 (isso é importante para evitar loop de renderização)
		// E então, seta o representante no estado
		if (this.props.userProps) {
			const { representativeId } = this.props.userProps;
			if (
				(representativeId || representativeId === 0) &&
				!this.state.representante &&
				this.state.representante !== 0
			) {
				this.setState({ representante: representativeId });
			}
		}
	}

	// Handlers

	handleSearchedSupervisor = (searchedSupervisor) =>
		this.setState({ searchedSupervisor });

	handleArticle = (articlesSelected) => this.setState({ articlesSelected });

	handleActiveIndex = (activeIndex) => this.setState({ activeIndex });

	/*
	 * Uma função para mudança de estado para todos
	 * os campos "Input" da tela, para melhorar a
	 * visualização do código.
	 */
	handleFieldChange = (e) => this.setState({ [e.target.name]: e.target.value });

	/*
	 * Uma função para mudança de estado para todos
	 * os campos "Date" da tela, para melhorar a
	 * visualização do código.
	 */

	handleClear = () =>
		this.setState({
			...INITIAL_STATE,
			articlesOptions: this.state.articlesOptions,
			articlesSelected: this.state.articlesOptions,
		});

	// Request

	// Quota Articles
	handleGetQuotaArticles = async () => {
		this.setState({
			isLoading: true,
			articlesSelected: [],
			articlesOptions: [],
		});
		try {
			const { data } = await api.comercial.filters.quotaArticle.getAll();

			if (data.length === 0) {
				toast.warn('Nenhum artigo encontrado!');
				return;
			}

			const articlesOptions = data.map((article) => articleToOptions(article));
			this.setState({ articlesOptions, articlesSelected: articlesOptions });
		} catch (err) {
			toast.error(`Erro ao consultar Artigos de Cotas: ${err.message}`);
		} finally {
			this.setState({ isLoading: false });
		}
	};

	getPerformance = async () => {
		const {
			representante,
			searchedRepresentante,
			searchedSupervisor,
			articlesSelected,
		} = this.state;

		const paramQuotaArticles = {
			...(articlesSelected.length > 0
				? { quotaArticles: articlesSelected.map(getValueFromOption).toString() }
				: {}),
		};

		const paramSearchedSupervisor = {
			...(searchedSupervisor.length > 0
				? { supervisors: searchedSupervisor.map(getValueFromOption).toString() }
				: {}),
		};

		const params = {
			representativeId:
				representante === 0 ? searchedRepresentante : representante,
			...paramSearchedSupervisor,
			...paramQuotaArticles,
		};
		this.setState({ isLoading: true, customerPerformance: [] });
		try {
			const { data: customerPerformance } =
				await api.comercial.performance.getPerformance({
					params: params,
				});

			this.setState({ customerPerformance });
		} catch (err) {
			toast.error(`Erro ao performance de clientes: ${err.message}`);
		} finally {
			this.setState({ isLoading: false, activeIndex: null });
		}
	};

	render() {
		const {
			// Filters
			representante,
			searchedRepresentante,
			articlesOptions,
			articlesSelected,

			// Data
			customerPerformance,

			// Page State
			isLoading,

			// isSending,
			activeIndex,
		} = this.state;

		if (representante === '')
			return (
				<div
					style={{
						display: 'flex',
						width: '100%',
						height: '100%',
						alignItems: 'center',
						justifyContent: 'center',
					}}
				>
					<Spinner size="xlarge" />
				</div>
			);

		return (
			<>
				<div className="acompVendas-container">
					<PrimeAccordion
						activeIndex={activeIndex}
						onTabChange={(e) => this.handleActiveIndex(e.index)}
						style={{ marginBottom: '0.8vh' }}
					>
						<AccordionTab header="Filtros">
							<Row>
								{representante === 0 && (
									<Col md={3}>
										<FormGroup>
											<FormLabel>Representante</FormLabel>
											<FormControl
												style={{ marginBottom: '20px' }}
												className="rounded-input"
												type="text"
												name="searchedRepresentante"
												value={searchedRepresentante}
												onChange={this.handleFieldChange}
												disabled={representante !== 0}
											/>
										</FormGroup>
									</Col>
								)}
								<Col md={2}>
									<FormGroup>
										<FormLabel>Coleções</FormLabel>
										<Popout
											name="artigo"
											buttonStyle={defaultButtonStyle}
											title="Selecione um(a)"
											isMulti
											isSearchable
											isClearable={true}
											maxDisplay={1}
											menuWidth={'100%'}
											options={articlesOptions}
											onChange={this.handleArticle}
											value={articlesSelected}
										/>
									</FormGroup>
								</Col>
								<Col md={3}>
									<div className="actions">
										<FormGroup style={{ marginTop: '29px' }}>
											<ButtonGroup>
												{
													<LoadingButton
														type="button"
														variant="success"
														title="Consultar"
														onClick={this.getPerformance}
														isLoading={isLoading}
													>
														{Button}
													</LoadingButton>
												}
												{
													<Button
														className="btn btn-secondary"
														onClick={this.handleClear}
													>
														Limpar
													</Button>
												}
											</ButtonGroup>
										</FormGroup>
									</div>
								</Col>
							</Row>
						</AccordionTab>
					</PrimeAccordion>
				</div>
				<CustomerPerformance rows={customerPerformance} />
			</>
		);
	}
}

export default withUser(CanceledOrders);
